<p>procedimento-escolher-tipo works!</p>
